import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import {api} from '../properties/endpoints';


@Injectable({
  providedIn: 'root'
})
export class DynamicNormService {

  constructor(private http: HttpClient) { }

  getAllDynamicNorm() {
    const url = `${api.host}/suggestion/list`;
    return this.http.get(url);
  }

  getDynamicNormForm() {
    const url = `${api.host}/suggestion/metadata`;
    return this.http.get(url);
  }


  getDynamicNormById(id){
    const url = `${api.host}/suggestion/id/${id}`;
    return this.http.get(url);
  }

  getDynamicNormAttributesByMaterialAndLocation(materialCode, locationCode){
    const url = `${api.host}/suggestion/attributes/materialcode/${materialCode}/locationcode/${locationCode}`;
   return this.http.get(url);
 }

  saveDynamicNorm(resultJson): Observable<any[]>{
    const locationSaveApi = `${api.host}/suggestion/save`;
    return this.http.post<any>(locationSaveApi, resultJson);
}

  publishSelectedNorm(request): Observable<ArrayBuffer>{
    const locationSaveApi = `${api.host}/suggestion/publish`;
    return this.http.post<any>(locationSaveApi, request,{responseType: 'text' as 'json'});
}

  saveDynamicNormAttributes(resultJsonAttributes): Observable<any[]>{
    const locationAttributeSaveApi = `${api.host}/suggestion/update/attributes`;
    return this.http.post<any>(locationAttributeSaveApi, resultJsonAttributes);
  }

  nextPage(page){
    const url = `${api.host}/suggestion/list?${page}`;
    return this.http.get(url);
  }

}
